// src/components/AdminRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AdminRoute = () => {
  const token = useSelector(state => state.authReducer.token);
  const user = useSelector(state => state.authReducer.user);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!user || (user.role !== 'admin' && user.role !== 'super_admin')) {
    return <Navigate to="/" replace />; // Redirect to main page if not admin
  }

  return <Outlet />;
};

export default AdminRoute;
